<template>
  <el-container v-loading="Project.active.isLoading"
                :element-loading-text="$t('Project is loading')"
                class="project-detail">
    <template v-if="Project.active.hasError">
      <InformationFetchingError :errors="Project.active.errors" />
    </template>

    <template v-if="Project.active.isLoaded && !Project.active.hasError">
      <el-aside class="dashboards-aside">
        <ProjectDashboards :project="Project.active.data" class="vertical invert" />
      </el-aside>

      <keep-alive>
        <router-view name="route_with_sidebar" :show-date-filter="showDateFilter" />
      </keep-alive>

      <el-main v-if="Project.active.isLoaded && !Project.active.hasError" class="project-detail__main">
        <keep-alive>
          <router-view :key="$route.fullPath" name="keep_alive" />
        </keep-alive>
        <router-view :key="key" @update-key="updateKey" />
      </el-main>
    </template>
  </el-container>
</template>

<script>
import posthog from 'posthog-js';
import { mapState, mapActions, mapMutations } from 'vuex';
import { version } from '../../../package.json';

// Components
import ProjectDashboards from '../project/components/ProjectDashboards';

export default {
  components: {
    ProjectDashboards
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      key: 0
    };
  },
  computed: {
    ...mapState(['Project', 'route']),
    showDateFilter() {
      return !(this.$route.name === this.Breadcrumbs.coverage);
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name !== this.Breadcrumbs.skuValidation) {
      this.cleanActiveProject();
      this.resetGlobalFilterState();
    }

    if (!window.location.href.includes('localhost')) {
      posthog.unregister('project_id');
      posthog.unregister(version);
    }
    next();
  },
  beforeCreate() {
    if (!document.getElementById('usetifulScript')) {
      // eslint-disable-next-line func-names
      (function (w, d, s) {
        const a = d.getElementsByTagName('head')[0];
        const r = d.createElement('script');
        r.async = 1;
        r.src = s;
        r.setAttribute('id', 'usetifulScript');
        r.dataset.token = 'c4ddfa98cbee832ddce511f0c3a4c40e';
        a.appendChild(r);
      }(window, document, 'https://www.usetiful.com/dist/usetiful.js'));
    }
  },
  created() {
    if (!this.Project.active.isLoaded) {
      this.fetchProject(this.projectId);
      if (!window.location.href.includes('localhost')) {
        posthog.register({
          project_id: this.projectId,
          version
        });
      }
    }
  },
  methods: {
    ...mapMutations(['resetGlobalFilterState']),
    ...mapActions(['fetchProject', 'cleanActiveProject']),
    updateKey() {
      this.key++;
    }
  }
};
</script>

<style lang="scss">
.project-detail {
  .dashboards-aside {
    width: 80px !important;
    overflow: initial;

    @include breakpoint(lg-min) {
      background-color: $andreaBlue;
    }
  }

  &__main {
    padding: 0;
  }
}

// Mobile
@include breakpoint(lg-max) {
  .project-detail {
    flex-direction: column;

    .dashboards-aside {
      width: 100% !important;

      .dashboards {
        .dashboard {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          width: 100%;
          height: 60px;
          margin-right: 3px;

          i {
            margin-right: 25px;
            margin-left: 20px;
            font-size: 23px;
          }

          small {
            font-size: 18px;
            opacity: 0.8;
          }
        }

        .top-menu-name {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          height: 25px;
          padding: 6px 0;
          font-weight: 600 !important;
          text-align: center;
          text-decoration: none;

          i {
            margin-top: 5px;
            color: #fff;
          }

          small {
            display: inline-block;
            padding: 0 5px;
            font-size: 18px;
            color: #fff;
          }
        }
      }
    }

    .filter-aside {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100% !important;
      height: 100%;
      overflow-x: hidden;

      .el-form-item__label,
      .el-form-item {
        padding-bottom: 0;
        margin-bottom: 5px;
      }

      button {
        width: 100%;
      }
    }
  }

  .menu-close {
    display: flex;
  }

  .dashboard-cntrl {
    .menu-web {
      display: block;
    }

    .resp-menu {
      display: none;
    }
  }

  .menu-web {
    display: none;
  }

  .menu-mobile {
    display: block;
  }

  .resp-menu {
    display: flex;
    justify-content: flex-end;

    i {
      display: flex;
      align-items: center;
      //padding: 0 0 0 8px;
      font-size: 30px;
      color: #fff;
    }

    .mdi-menu {
      margin: 0 11px 0 0;
    }

    .mdi-account-multiple {
      margin: 0 0 0 8px;
    }
  }

  .executive-analysis {
    svg {
      margin-left: 15px;
    }
  }
}
</style>
